/**
 * Used to handle session timeouts and page not found errors.
 * Kentico will handle 404's as well but using this as a back up
 * `error` is passed in as a boolean and toggles the behaviour of the component
 */

import React, { useGlobal } from "reactn";
import PropTypes from "prop-types";

import SideNav from "shared-anpost-components/components/SideNav/SideNav";
// hooks
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

import PageTitle from "../pageTitle/PageTitle.styled";
import PageText from "../pageText/PageText.styled";


// containers
import AccountContainerStyled from "../containers/AccountContainer/AccountContainer.styled";
import LeftContainerStyled from "../containers/LeftContainer/LeftContainer.styled";
import RightContainerStyled from "../containers/RightContainer/RightContainer.styled";
import { ContentContainerStyled } from "../contentContainer/ContentContainer.styled";

const NotFound = ({ history, error }) => {
    // func to reload the page
    const reload = () => {
        history.push("/");
    };

     // hooks
	const { isMobile } = DetectDeviceResize();
    const [isBusiness] = useGlobal("isBusiness");
    const [isCollapsed] = useGlobal("isCollapsed");


    return ( 
    <>
        <AccountContainerStyled>
            {!isMobile && (
                <LeftContainerStyled className={isCollapsed ? "collapsed" : ""}>
                    <SideNav business={isBusiness} />
                </LeftContainerStyled>
            )}
            <RightContainerStyled>
                <ContentContainerStyled>
                    <PageTitle className="color--grey-d">{error ? "Sorry! We couldn't find that Page." : "Session expired"}</PageTitle>
                    {!error && (
                        <>
                            <PageText>Please try agains</PageText>
                            <button type="button" className="bn bn--primary gtm-cta" onClick={reload}>
                                Try again
                            </button>
                        </>
                    )}
                </ContentContainerStyled>
            </RightContainerStyled>
        </AccountContainerStyled>
    </>
    );
};

export default NotFound;

// props validation
NotFound.propTypes = {
    /**
     * Passed in so that the start of the app can be reloaded when refresh button is clicked
     */
    history: PropTypes.object,
    /**
     * Bool that shows a different message with a CTA to reload app
     */
    error: PropTypes.bool
};
